<script setup>
import InputOtp from 'primevue/inputotp';

import { useForm, Link, Head } from '@inertiajs/vue3';

const props = defineProps({
    qrcode_image: String,
    secret: String
});

const form = useForm({
    secret: props.secret,
    code: '',
});

function submit() {
    form.post('/portal/two_factor', {
        onSuccess: () => {
            //
        },
        onError: () => {
            form.reset('code');
        },
        preserveScroll: true
    });
}

//on enter, submit form
window.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
        submit();
    }
});
</script>

<template>
    <Head title="Twee factor authenticatie | Mijnautosnelweg" />
    <div class="mt-5">
        <!-- Create div that shows the google qrcode image so you can scan it the first time you see this page -->
        <div class="flex flex-col justify-center text-center" v-if="form.secret && form.secret.length > 0">
            <div class="font-bold text-xl mb-2">Twee factor authenticatie</div>
            <p class="text-color-secondary block mb-5">Scan onderstaande QR code met de Google Authenticator app.</p>
            <img :src="'data:image/svg+xml;base64, ' + props.qrcode_image" alt="QR Code" class="mb-5 mx-auto" width="300" />
        </div>

        <form @submit.prevent="submit">
            <input type="hidden" v-model="form.secret" />
            <div class="flex flex-col justify-center text-center items-center">
                
                <div class="font-bold text-xl mb-2" v-if="!form.secret">Twee factor authenticatie</div>
                
                <p class="text-color-secondary block mb-5">Voer de code in die in je Google Authenticator zichtbaar is.
                </p>
                <InputOtp class="justify-center twoFactorInput" v-model="form.code" :length="6" integerOnly />
                <div class="text-red-500" v-if="form.errors.code">{{ form.errors.code }}</div>

                <button type="submit"
                    class="flex mt-5 w-20 align justify-center rounded-md bg-brightorange px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-brightorange focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brightorange">Versturen</button>
            </div>
        </form>
    </div>

</template>